<template>
  <div class="share-page">
    <div class="top-bg"></div>
    <div class="top-box flex-column-start-center ">
      <div class="title">{{$t('share.desc1')}}</div>
      <div class="sub-title">{{$t('share.desc2')}}</div>
    </div>

    <div class="share-box">
      <div class="modal-title" >{{ $t('index.menu3') }}</div>

      <div class="label">{{ $t('yao-qing-lian-jie') }}</div>
      <div class="flex-center share-line">
        <span class="value">{{shareLink}}</span>
        <span class="btn flex-center" @click="copyData(1)">{{ $t('fu-zhi') }}</span>
      </div>

      <div class="label">{{i18n.t('share.label3')}}</div>
      <div class="flex-center share-line ">
        <span class="value">{{shareCode}}</span>
        <span class="btn flex-center" @click="copyData(1)">{{ $t('fu-zhi-0') }}</span>
      </div>

      <div class="flex-center-between title">
        <div class="">{{ $t('pageTitle.myShare') }}</div>
        <div class="flex-center more" @click="showModal">
          {{ $t('pageTitle.shareRole') }} <Icon name="arrow" size="12" class="ml-5" color="#4F5966"/>
        </div>
      </div>

      <div class="my-share">
        <div class="share-statistics flex-center">
          <div class="flex-1 flex-column-start-center">
            <div class="desc">{{$t('share.label6')}}</div>
            <div class="count">{{statisticsData.Total}}</div>
          </div>
          <div class="flex-1 flex-column-end-center">
            <div class="desc">{{$t('share.label7')}}(USDT)</div>
            <div class="count">{{statisticsData.TotalIncome}}</div>
          </div>
        </div>

        <div class="share-table">
          <div class="th-line flex">
            <div class="th flex-2">{{ $t('yong-hu-uid') }}</div>
            <div class="th flex-2">{{ $t('share.label9') }}</div>
            <div class="th flex-1">{{ $t('wo-de-shou-yi') }}</div>
          </div>

          <div class="td-line flex" v-for="(item, i) in shareList" :key="i">
            <div class="td flex-2 bold">{{item.UId}}</div>
            <div class="td flex-2">{{item.OptionTransactionNum + item.OptionTransactionNum}}</div>
            <div class="td flex-1">{{item.ParentProfitAmount}}</div>
          </div>
        </div>
      </div>

    </div>

    <div class="page-modal" v-show="showShare">
      <div class="title flex-center-between">
        <span>{{ $t('pageTitle.shareRole') }}</span>
        <img :src="closeUrl" alt="" @click="cancel">
      </div>
      <div class="content">
        <div class="detail">{{$t('share.role1')}}</div>
        <div class="detail">{{$t('share.role2')}}</div>
        <div class="detail">{{$t('share.role3')}}</div>

        <div class="detail ">{{$t('share.role4')}}</div>
        <div class="detail">{{$t('share.role5')}}</div>
        <div class="detail">{{$t('share.role6')}}</div>
      </div>

      <div class="btn">
        <Button @click="cancel">{{ $t('addAddress.btn2') }}</Button>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard';
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'
import { Button, Popup, Icon } from 'vant'
import { shareStatistics, userInfo } from '@/api/user'
export default {
  components: {
    Button,
    Popup,
    Icon,
  },
  data() {
    return {
      shareList: [],
      closeUrl: require('../../assets/imgs/icon-close2.png'),
      statisticsData: {
        Total: 0,
        TotalIncome: 0,
      },
      page: {
        page: 1,
        limit: 10
      },
      showShare: false,
    }
  },
  computed: {
    shareLink() {
      return this.$store.state.promoteUrl + '#/register?code=' + this.shareCode
    },
    shareCode() {
      return this.$store.state.shareCode
    },
    screenScale() {
      return this.$store.state.screenScale
    },
  },
  mounted() {
    this.init()
    this.initUser()
  },
  methods: {
    init() {
      let form = new FormData()
      form.append('current', this.page.page)
      form.append('pageSize', this.page.limit)
      shareStatistics(form).then(res => {
        let data = res.data
        this.shareList = data.InviteList || []
        this.statisticsData.Total = this.shareList.length
        this.statisticsData.TotalIncome = 0
        this.shareList.forEach(v => {
          this.statisticsData.TotalIncome += v.ParentProfitAmount
        })
        this.isInit = true
      })
    },
    initUser() {
      userInfo().then(res => {
        this.$store.state.shareCode = res.data.InviteCode
      })
    },
    back() {
      this.$router.go(-1)
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    copyData(type) {
      let data = type == 1 ? this.shareCode : this.shareLink
      const clipboard = new Clipboard('.copy-icon', {text: () => data});
      this.$toast.success(this.i18n.t('recharge.success'))
    },
    showModal() {
      this.showShare = true
      this.$store.state.showModalBg = true
    },
    cancel() {
      this.showShare = false
      this.$store.state.showModalBg = false
    },
    linkClick(i) {
      if (i == 0) {
        this.copyData(2)
      } else if (i == 1) {
        html2canvas(this.$refs.modalRef).then(canvas => {
          let a = document.createElement('a')
          a.href = canvas.toDataURL("image/png")
          a.download = `${this.i18n.t('share.img')}.png`
          var clickevent = document.createEvent('MouseEvents');
          clickevent.initEvent('click', true, false);
          a.dispatchEvent(clickevent);
        })
      }
    }
  }
}
</script>